import { render, staticRenderFns } from "./All_data.vue?vue&type=template&id=31e36899&style=true"
import script from "./All_data.vue?vue&type=script&lang=js"
export * from "./All_data.vue?vue&type=script&lang=js"
import style0 from "./All_data.vue?vue&type=style&index=0&id=31e36899&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports